import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/topic'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(topic) {
    return http.post(`${resource}`, topic)
  },
  update(company, uuid) {
    return http.put(`${resource}/${uuid}?_method=PATCH`, company)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
